import React, { useEffect, useState } from "react";
import { Badge, Button, Col, Row, Table } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import BusinessHours from "src/components/BusinessHours";
import GoBackButton from "src/components/GoBackButton";
import MultiImageUploader from "src/components/MultimageUpload";
import MultiVideoUploader from "src/components/MultiVideoUpload";
import OSMap from "src/components/OSMap";
import Title from "src/components/Title";
import API from "src/services/api";
import TableFormatter from "src/utils/tableFormatter";

const SwipeDetailSite = () => {
  const { swipe_id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [taData, setTaData] = useState(null);

  const [trigger, setTrigger] = useState(0);

  const loadData = async () => {
    const res = await API.getSwipe(swipe_id);
    if (res.status === true) {
      setData(res.data);
    } else {
      setData(null);
    }
    setIsLoading(false);
  };

  // Load notes when component is rendered the first time
  useEffect(() => {
    if (swipe_id) {
      loadData();
    }
  }, [swipe_id]);

  const deleteSwipe = async () => {
    if (window.confirm("Swipe löschen?")) {
      await API.deleteSwipe(swipe_id);
      loadData();
    }
  };

  const markAsChecked = async () => {
    if (window.confirm("Als geprüft markieren?")) {
      await API.checkedSwipe(swipe_id);
      loadData();
    }
  };

  const loadTripAdvisor = async () => {
    const data = await API.loadSwipeTripadvisor(swipe_id);
    setTaData(data);
  };

  async function fetchImageAsBlob(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Bild konnte nicht geladen werden");
    return await response.blob();
  }

  async function uploadImageFromUrl(imageUrl) {
    if (window.confirm("Bild importieren?")) {
      try {
        const blob = await fetchImageAsBlob(imageUrl);

        // Optional: in ein File-Objekt mit Dateinamen umwandeln
        const file = new File([blob], "image.jpg", { type: blob.type });

        const formData = new FormData();
        formData.append("source", "TRIPADVISOR");
        formData.append("images[]", file); // Der Schlüsselname hängt von deiner API ab

        const response = await API.uploadSwipeImage(swipe_id, formData);

        setTrigger((prev) => prev + 1);

        const result = await response.json();
        console.log("Upload erfolgreich:", result);
      } catch (error) {
        console.error("Fehler beim Upload:", error);
      }
    }
  }

  if (isLoading) {
    return <Title>Wird geladen...</Title>;
  }

  if (data == null || data === undefined) {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Title>Eintrag nicht gefunden oder gelöscht</Title>
          </Col>
        </Row>
        <Row>
          <Col>
            <GoBackButton />
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Swipe</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <GoBackButton />
        </Col>
        <Col className="text-end">
          <Button variant="success" onClick={() => markAsChecked()}>
            Eintrag geprüft
          </Button>{" "}
          <Button variant="success" onClick={() => loadTripAdvisor()}>
            Tripadvisor
          </Button>{" "}
          <Button
            variant="default"
            onClick={() => navigate(`/swipe/edit/${swipe_id}`)}
          >
            Bearbeiten
          </Button>{" "}
          <Button variant="danger" onClick={() => deleteSwipe()}>
            Löschen
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className="add-margin">
          <Table>
            <tbody>
              <tr>
                <th>ID</th>
                <td>{data.id}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{data.status}</td>
              </tr>
              <tr>
                <th>Quelle</th>
                <td>{data.source}</td>
              </tr>
              <tr>
                <th>Swipe-Typ</th>
                <td>{data.swipetype_id}</td>
              </tr>

              <tr>
                <th>Name</th>
                <td>{data.name}</td>
              </tr>
              <tr>
                <th>Strasse</th>
                <td>{data.street}</td>
              </tr>
              <tr>
                <th>Strassen-Nr</th>
                <td>{data.street_no}</td>
              </tr>
              <tr>
                <th>PLZ</th>
                <td>{data.postcode}</td>
              </tr>
              <tr>
                <th>Ort</th>
                <td>{data.city}</td>
              </tr>
              <tr>
                <th>Land</th>
                <td>{data.country}</td>
              </tr>
              <tr>
                <th>Telefon</th>
                <td>{data.phone}</td>
              </tr>
              <tr>
                <th>E-Mail</th>
                <td>{data.email}</td>
              </tr>
              <tr>
                <th>Webseite</th>
                <td>
                  {data.website && (
                    <a href={data.website} target="_blank" rel="noreferrer">
                      {data.website}
                    </a>
                  )}
                </td>
              </tr>
              <tr>
                <th>Zefix ID</th>
                <td>{data.zefix_id}</td>
              </tr>
              <tr>
                <th>Zefix Name</th>
                <td>{data.zefix_name}</td>
              </tr>
              <tr>
                <th>Beschreibung</th>
                <td>{data.description}</td>
              </tr>

              <tr>
                <th>Erstellt am</th>
                <td>{TableFormatter.formatDateTime(data.created_at)}</td>
              </tr>
              <tr>
                <th>Geändert am</th>
                <td>{TableFormatter.formatDateTime(data.updated_at)}</td>
              </tr>
              <tr>
                <th>Zuletzt geprüft am</th>
                <td>{TableFormatter.formatDateTime(data.checked_at)}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
        <Col className="add-margin">
          <Table>
            <tbody>
              <tr>
                <th>Geo-Hash</th>
                <td>{data.geohash}</td>
              </tr>
              <tr>
                <th>Latitude</th>
                <td>{data.latitude}</td>
              </tr>
              <tr>
                <th>Longitude</th>
                <td>{data.longitude}</td>
              </tr>
            </tbody>
          </Table>
          <OSMap lat={data.latitude} long={data.longitude} />
        </Col>
      </Row>
      <Row>
        <Col className="add-margin">
          <h2>Öffnungszeiten</h2>
          <BusinessHours data={data.business_hours} />
        </Col>
        <Col className="add-margin">
          <h2>Tags</h2>
          {data.tags.map((i) => (
            <Badge style={{ marginRight: "5px" }}>{i.name}</Badge>
          ))}
        </Col>
        <Col className="add-margin">
          <h2>Bilder</h2>
          <MultiImageUploader swipeId={swipe_id} trigger={trigger} />
        </Col>
        <Col className="add-margin">
          <h2>Videos</h2>
          <MultiVideoUploader swipeId={swipe_id} />
        </Col>
      </Row>

      {taData && (
        <Row>
          <Col className="add-margin">
            <h2>Fotos</h2>
            {taData.data.photo.data.map((i, index) => {
              const url = i?.images?.original?.url;
              return url ? (
                <img
                  key={index}
                  src={url}
                  style={{ width: 200 }}
                  onClick={() => uploadImageFromUrl(url)}
                />
              ) : null;
            })}
          </Col>

          <Col className="add-margin">
            <h2>Suche</h2>
            <pre>{JSON.stringify(taData.data.data, null, 2)}</pre>
          </Col>
          <Col className="add-margin">
            <h2>Details</h2>
            <pre>{JSON.stringify(taData.data.detail, null, 2)}</pre>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default SwipeDetailSite;
